<svg fill="none" height="28" viewBox="0 0 28 28" width="28" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M14 0C6.272 0 0 6.272 0 14C0 21.728 6.272 28 14 28C21.728 28 28 21.728 28 14C28 6.272
        21.728 0 14 0ZM7.098 22.792C7.7 21.532 11.368 20.3 14 20.3C16.632 20.3 20.314 21.532 20.902 22.792C18.998
        24.304 16.604 25.2 14 25.2C11.396 25.2 9.002 24.304 7.098 22.792ZM22.904 20.762C20.902 18.326 16.044 17.5 14
        17.5C11.956 17.5 7.098 18.326 5.096 20.762C3.668 18.886 2.8 16.548 2.8 14C2.8 7.826 7.826 2.8 14 2.8C20.174 2.8 25.2
        7.826 25.2 14C25.2 16.548 24.332 18.886 22.904 20.762ZM14 5.6C11.284 5.6 9.1 7.784 9.1 10.5C9.1 13.216 11.284 15.4 14
        15.4C16.716 15.4 18.9 13.216 18.9 10.5C18.9 7.784 16.716 5.6 14 5.6ZM14 12.6C12.838 12.6 11.9 11.662 11.9 10.5C11.9 9.338
        12.838 8.4 14 8.4C15.162 8.4 16.1 9.338 16.1 10.5C16.1 11.662 15.162 12.6 14 12.6Z"
    fill="white"
    fill-opacity="0.65"
  />
</svg>
